import { Alignment } from '@faire/web-api--source/indigofair/data/Alignment';
import { BannerVariant } from '@faire/web-api--source/indigofair/data/BannerVariant';
import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { IAction } from '@faire/web-api--source/indigofair/data/IAction';
import { IBackgroundIcon } from '@faire/web-api--source/indigofair/data/IBackgroundIcon';
import { IButtonElement } from '@faire/web-api--source/indigofair/data/IButtonElement';
import { IImage } from '@faire/web-api--source/indigofair/data/IImage';
import { IResponsiveBackgroundIcon } from '@faire/web-api--source/indigofair/data/IResponsiveBackgroundIcon';
import { IResponsiveImages } from '@faire/web-api--source/indigofair/data/IResponsiveImages';
import { IResponsiveWidthConstraint } from '@faire/web-api--source/indigofair/data/IResponsiveWidthConstraint';
import { ITextElement } from '@faire/web-api--source/indigofair/data/ITextElement';
import { WidthConstraint } from '@faire/web-api--source/indigofair/data/WidthConstraint';

export namespace IBannerComponent {
  export namespace IBannerStyle {
    /**
     * Return an instance of IBannerStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IBannerStyle>): IBannerStyle =>
      ({
        ...(partial ?? {}),
      }) as IBannerStyle;
  }

  export interface IBannerStyle {
    variant: keyof typeof BannerVariant | undefined;
    header_width: keyof typeof WidthConstraint | undefined;
    description_width: keyof typeof WidthConstraint | undefined;
    responsive_header_width: IResponsiveWidthConstraint | undefined;
    responsive_description_width: IResponsiveWidthConstraint | undefined;
    background_color: keyof typeof ColorTokenKey | undefined;
    /**
     * @protobufOption (faire.protobuf.validation) = HEX_COLOR_NO_HASH
     */
    background_color_hex: string | undefined;
  }

  export type AppDownloadPhoneInputCTAElement = unknown;

  /**
   * Return an instance of IBannerComponent with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IBannerComponent>
  ): IBannerComponent =>
    ({
      images: [],
      description: [],
      on_click: [],
      ...(partial ?? {}),
    }) as IBannerComponent;
}

/**
 * Banner
 */
export interface IBannerComponent {
  style: IBannerComponent.IBannerStyle | undefined;
  images: Array<IImage>;
  title: ITextElement | undefined;
  sub_title: ITextElement | undefined;
  description: Array<ITextElement>;
  button: IButtonElement | undefined;
  tagline: ITextElement | undefined;
  /**
   * Specify the onClick behavior of the click on the banner itself.
   */
  on_click: Array<IAction>;
  responsive_images: IResponsiveImages | undefined;
  vertical_content_alignment: keyof typeof Alignment | undefined;
  background_icon: IBackgroundIcon | undefined;
  responsive_background_icon: IResponsiveBackgroundIcon | undefined;
  /**
   * Intended to be used for text that is displayed in the lower portion in the component
   */
  disclaimer: ITextElement | undefined;
  app_download_phone_input_c_t_a_element:
    | IBannerComponent.AppDownloadPhoneInputCTAElement
    | undefined;
}
